import Divider from "components/ui/divider"
import Image from "components/ui/image"
import { IS_NA, jewlr_t } from "helpers/application"

const Perks = () => {
  const is_na = IS_NA()

  return (
    <div className="contained tablet:px-0 mb-40">
      <Divider className="bg-grey-20 mb-40 mt-20" />
      <div className="tablet:grid-cols-[repeat(4,100px)] tablet:gap-32 desktop:gap-56 grid grid-cols-[repeat(4,54px)] justify-center gap-16">
        <div className="text-center">
          <Image
            alt={`FREE ${jewlr_t("terms.Shipping")}`}
            className="h-27 tablet:h-54 mb-10 w-auto"
            height="44"
            src={require("images/layout/footer/perks/shipping.svg")}
            width="61"
          />
          <p className="text-10 tablet:text-14 leading-11 tablet:leading-17 mx-auto font-medium">
            FREE {jewlr_t("terms.Shipping")}
          </p>
        </div>
        <div className="text-center">
          <Image
            alt="One-Year Warranty"
            className="h-26 tablet:h-54 mb-10 w-auto"
            height="52"
            src={require("images/layout/footer/perks/1-year-warranty.svg")}
            width="56"
          />
          <p className="text-10 tablet:text-14 leading-11 tablet:leading-17 tablet:px-8 mx-auto font-medium">
            One-Year Warranty
          </p>
        </div>
        <div className="text-center">
          <Image
            alt="99-Day Returns"
            className="h-26 tablet:h-52 mb-10 w-auto"
            height="52"
            src={require("images/layout/footer/perks/99-day-returns.svg")}
            width="52"
          />
          <p className="text-10 tablet:text-14 leading-11 tablet:leading-17 tablet:px-16 mx-auto font-medium">
            99-Day Returns
          </p>
        </div>
        <div className="text-center">
          <Image
            alt={`Made In ${is_na ? "USA & Canada" : "North America"}`}
            className="tablet:h-47 mb-10 h-24 w-auto"
            height="47"
            src={require("images/layout/footer/perks/diamond.svg")}
            width="62"
          />
          <p className="text-10 tablet:text-14 leading-11 tablet:leading-17 tablet:px-5 mx-auto font-medium">
            Made in {is_na ? "USA & Canada" : "North America"}
          </p>
        </div>
      </div>
    </div>
  )
}

export default Perks
